import React from 'react';
import { useParams } from 'react-router-dom';
import { Table, Params, Actions } from 'nallian-table-builder-ui';
import apiRoutes from '../../../../app/api/routes';

const AppInstallationCommunities = () => {
  const { id, installationId } = useParams();

  return (
    <>
      <Table
        resource={`installations_community_${id}_${installationId}`}
        url={apiRoutes.appInstallationCommunities(id, installationId)}
        pageSize={50}
        idProp="id"
        noUserSettings
        filtered
        sorted
      >
        <Actions.Link
          iconbutton
          width="2.5rem"
          icon="eye"
          align="center"
          url="/communities/edit/:id/apps"
        />
        <Params.String name="name" width="16rem" minWidth="16rem" grow noFilter />
        <Params.String name="tag" width="16rem" minWidth="16rem" grow noFilter />
      </Table>
    </>
  );
};

export default AppInstallationCommunities;
